const ORIGIN = window.location.origin;
const SLOTS_HOME_URL = `homeurl=${ORIGIN}/games/slots`;
const VIVO_OPERATOR_ID = 1000138;

export const getTomhornGamesURL = ({
  serverId = 6401748,
  token,
  langType = "en",
  gameID,
}) => {
  if(!token){
    return `https://s4.toogri.com/cwguestlogin.do?bankId=92C339E8-14B5-4572-8B8E-C030E1E0300A&gameID=${gameID}&lang=${langType}&${SLOTS_HOME_URL}`
  }
  return `https://www.2vivo.com/FlashRunGame/Prod/RunTomHornGame.aspx?GameID=${gameID}&serverid=${serverId}&Token=${token}&lang=${langType}&OperatorID=${VIVO_OPERATOR_ID}&${SLOTS_HOME_URL}`;
};

export const getBetsoftGamesURL = ({
  serverId = 6401748,
  token,
  langType = "en",
  gameID
}) => {
  if(!token){
    return `https://streamtech-c2ss.betsoftgaming.com/cwguestlogin.do?gameId=${gameID}&lang=${langType}&bankId=ED`
  }
  return `https://www.2vivo.com/FlashRunGame/RunRngGame.aspx?Token=${token}&serverid=${serverId}&lang=${langType}&operatorID=${VIVO_OPERATOR_ID}&gameID=${gameID}`;
};

export const getVirtualSportsGamesURL = ({ gameType, gamblerId, token, lang = "en" }) => {
  if(!token){
    return `https://rgs.betradar.com/bgw-auth-generic/auth/register?key=BLrLziTdLaenpyTM&gameType=${gameType}&lang=${lang}`
  }
  return `https://rgs.betradar.com/bgw-auth-generic/auth/register?key=BLrLziTdLaenpyTM&gameType=${gameType}&lang=${lang}&clientId=${gamblerId}&id=${token}`;
};

export function openBetsolutionGameWindow(config) {
  if (window.BETSOLUTION_GAME_WINDOW) {
    window.BETSOLUTION_GAME_WINDOW.close()
  }

  const startUrl = window.Charismatic.Casino.GameStarter.getGameStartUrl(config)
  window.BETSOLUTION_GAME_WINDOW = window.open(
    startUrl,
    'Betsolutions',
    'width=1600,height=900,menubar=no,toolbar=no,location=no'
  )
}


// WEBPACK FOOTER //
// ./js/config/games.js